import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as LogOutIcon } from './logOut.svg';

export const LogOut = IconHOC(LogOutIcon);
